<template>
  <ul>
    <li v-for="(category, index) in items" :key="index">
      <label class="container_check">
        {{ category.name }}
        <input v-model="category.checked" type="checkbox" />
        <span class="checkmark"></span>
      </label>
    </li>
  </ul>
</template>
<script>
export default {
  name: "CheckboxList",
  props: {
    items: {
      type: Object,
      default: {},
    },
    itemValue: {
      type: String,
      default: null,
    },
  },
  watch: {
    items: {
      deep: true,
      handler: function() {
        this.emit();
      },
    },
  },
methods: {
  emit() {
    var data = this.items.filter((item) => item.checked == true)
    if (this.itemValue) {
      data = data.map(item => item[this.itemValue])
    }
    this.$emit("input", data)
  },
},

};
</script>



<style>
/* Forms styles */
.container_check {
  
  position: relative;
  padding-left: 30px;
  line-height: 1.7;
  margin-bottom: 8px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container_check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.container_check input:checked ~ .checkmark {
  background-color: var(--brand-primary);
  border: 1px solid transparent;
}
.container_check .checkmark {
  display: block !important;
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border: 1px solid #d2d8dd;
  background-color: #fff;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  border-radius: 3px;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.container_check .checkmark:after {
  /* content: ""; */
  position: absolute;
  display: none;
  left: 11px !important;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.container_check input:checked ~ .checkmark:after {
  display: block;
}
</style>